import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

// Correcao critica -- vazamento entre tenants: NOTIF_KEY era uma chave FIXA
// e global no localStorage, entao toda notificacao de QUALQUER oficina
// aberta nesse navegador ficava visivel no sino de notificacoes de
// QUALQUER OUTRA oficina (ex.: agendamento criado na oficina A aparecendo
// no sino da oficina B). Agora a chave e isolada por tenant, igual
// saas_config_tenant_X ja fazia para o resto da configuracao.
function getTenantIdAtual() {
  try {
    const token = sessionStorage.getItem("access_token") || localStorage.getItem("access_token");
    if (!token) return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id") || localStorage.getItem("tenant_id")) || "1"; }
}
function getNotifKey() { return "saas_notificacoes_tenant_" + getTenantIdAtual(); }

// Descobre o timestamp de criacao da OS de forma confiavel. Antes o alerta de
// "OS parada" usava (os._criadoEm || 0): quando _criadoEm faltava, virava 0
// (01/01/1970) e o calculo dava numeros absurdos (ex.: "495625h"). Agora, se
// nao houver _criadoEm valido, tenta a data "criada" (pt-BR); se nada for
// confiavel, retorna null e o alerta e ignorado.
function getCriadoEmOS(os) {
  if (os._criadoEm && os._criadoEm > 0) return os._criadoEm;
  if (os.criada && typeof os.criada === "string") {
    try {
      const [dataParte, horaParte] = os.criada.replace(",", "").trim().split(/\s+/);
      const [d, m, y] = dataParte.split("/").map(Number);
      const [hh = 0, mi = 0, ss = 0] = (horaParte || "").split(":").map(Number);
      const t = new Date(y, (m || 1) - 1, d, hh, mi, ss).getTime();
      if (!Number.isNaN(t)) return t;
    } catch {}
  }
  return null;
}

// Formata a duracao de forma clara: horas ate 48h, depois dias.
function formatarTempoParado(horas) {
  if (horas >= 48) { const dias = Math.floor(horas / 24); return dias + (dias === 1 ? " dia" : " dias"); }
  const h = Math.round(horas);
  return h + (h === 1 ? " hora" : " horas");
}

function carregarNotifs() {
  try { return JSON.parse(localStorage.getItem(getNotifKey()) || "[]"); } catch { return []; }
}
function salvarNotifs(lista) {
  try { localStorage.setItem(getNotifKey(), JSON.stringify(lista.slice(0, 50))); } catch {}
}
export function adicionarNotificacao(tipo, titulo, msg, osId) {
  const notifs = carregarNotifs();
  const nova = { id: Date.now(), tipo, titulo, msg, osId: osId || null, lida: false, em: new Date().toLocaleString("pt-BR") };
  salvarNotifs([nova, ...notifs]);
  if (Notification.permission === "granted") {
    new Notification("SAAS.GL - " + titulo, { body: msg, icon: "/favicon.ico" });
  }
  window.dispatchEvent(new CustomEvent("saas_notif", { detail: nova }));
}

const TIPOS_COR = {
  nova_os:   { bg: "#6366f122", cor: "#818cf8", dot: "#6366f1", icon: "📋" },
  status:    { bg: "#3b82f622", cor: "#60a5fa", dot: "#3b82f6", icon: "🔄" },
  aprovacao: { bg: "#f9731622", cor: "#fb923c", dot: "#f97316", icon: "⏳" },
  concluido: { bg: "#22c55e22", cor: "#4ade80", dot: "#22c55e", icon: "✅" },
  alerta:    { bg: "#eab30822", cor: "#fde047", dot: "#eab308", icon: "⚠️" },
};

// Mapa idioma i18next -> locale de formatacao de data/hora. "pt" aqui
// resolve pra "pt-BR" (nao existe genero "pt" puro no toLocale*).
const LOCALE_POR_IDIOMA = { pt: "pt-BR", en: "en-US", es: "es-ES" };

export default function Header({ config, isMobile, onMenuClick }) {
  const { t, i18n } = useTranslation();
  const localeAtual = LOCALE_POR_IDIOMA[(i18n.resolvedLanguage || i18n.language || "pt").slice(0, 2)] || "pt-BR";
  const [hora, setHora]     = useState(new Date());
  const [notifs, setNotifs] = useState(carregarNotifs());
  const [aberto, setAberto] = useState(false);
  const naoLidas = notifs.filter(n => !n.lida).length;

  const recarregar = useCallback(() => setNotifs(carregarNotifs()), []);

  useEffect(() => {
    const t = setInterval(() => setHora(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  useEffect(() => {
    if (Notification.permission === "default") Notification.requestPermission();
    window.addEventListener("saas_notif", recarregar);
    const check = setInterval(() => {
      try {
        // Mesma correcao -- ler a lista de OS isolada por tenant, nao a
        // chave global antiga (que tambem podia gerar alerta de "OS parada"
        // usando dados de outra oficina).
        const lista = JSON.parse(localStorage.getItem("os_cache_tenant_" + getTenantIdAtual()) || "[]");
        const agora = Date.now();
        lista.forEach(os => {
          if (["Recepcao","Diagnostico","Aguardando Aprovacao","Em Servico"].includes(os.status)) {
            const criadoEm = getCriadoEmOS(os);
            if (!criadoEm) return; // sem data confiavel: nao gera alerta
            const horas = (agora - criadoEm) / (1000 * 60 * 60);
            if (horas > 24) {
              const n2 = carregarNotifs();
              if (!n2.find(n => n.osId === os.id && n.tipo === "alerta")) {
                const tempo = formatarTempoParado(horas);
                adicionarNotificacao("alerta", "OS parada ha " + tempo, os.id + " em " + os.status + " - " + os.cliente + " sem movimentacao ha " + tempo, os.id);
                recarregar();
              }
            }
          }
        });
      } catch {}
    }, 5 * 60 * 1000);
    return () => { window.removeEventListener("saas_notif", recarregar); clearInterval(check); };
  }, [recarregar]);

  const marcarLida = (id) => { const n = notifs.map(x => x.id === id ? { ...x, lida: true } : x); salvarNotifs(n); setNotifs(n); };
  const marcarTodasLidas = () => { const n = notifs.map(x => ({ ...x, lida: true })); salvarNotifs(n); setNotifs(n); };
  const limparTodas = () => { salvarNotifs([]); setNotifs([]); };

  return (
    <div id="main-header" style={{ alignItems:"center", background:"var(--bg)", borderBottom:"1px solid var(--border)", display:"flex", gap:0, height:60, justifyContent: isMobile ? "space-between" : "space-between", left:"var(--sidebar-w)", padding: isMobile ? "0 14px" : "0 24px", position:"fixed", right:0, top:0, zIndex:99 }}>

      {isMobile && (
        <button onClick={onMenuClick} aria-label={t("header.abrir_menu")} style={{ alignItems:"center", background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:8, color:"var(--text)", cursor:"pointer", display:"flex", flexShrink:0, fontSize:16, justifyContent:"center", padding:"6px 10px" }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>
        </button>
      )}

      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", minWidth: 0, paddingX: 16 }}>
      </div>

      <div style={{ alignItems:"center", display:"flex", gap:16, flexShrink:0 }}>

      <div style={{ flexShrink:0, position:"relative" }}>
        <button onClick={() => setAberto(!aberto)} style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:8, color:"var(--text2)", cursor:"pointer", fontSize:16, padding:"6px 10px" }}>
          🔔
        </button>
        {naoLidas > 0 && (
          <span style={{ background:"#ef4444", borderRadius:99, color:"#fff", fontSize:9, fontWeight:700, padding:"1px 5px", position:"absolute", right:-4, top:-4 }}>
            {naoLidas > 9 ? "9+" : naoLidas}
          </span>
        )}
        {aberto && (
          <div style={{ background:"var(--bg3)", border:"1px solid var(--border)", borderRadius:12, boxShadow:"0 8px 32px #0008", position:"absolute", right: isMobile ? -50 : 0, top:44, width: isMobile ? "calc(100vw - 28px)" : 360, maxWidth: 360, zIndex:999 }}>
            <div style={{ alignItems:"center", borderBottom:"1px solid var(--border)", display:"flex", justifyContent:"space-between", padding:"14px 16px" }}>
              <div style={{ fontSize:14, fontWeight:700 }}>
                {t("header.notificacoes")} {naoLidas > 0 && <span style={{ background:"#ef444422", borderRadius:99, color:"#ef4444", fontSize:11, padding:"2px 8px" }}>{naoLidas} {t("header.novas")}</span>}
              </div>
              <div style={{ display:"flex", gap:8 }}>
                {naoLidas > 0 && <button onClick={marcarTodasLidas} style={{ background:"none", border:"none", color:"var(--text3)", cursor:"pointer", fontSize:11 }}>{t("header.marcar_todas_lidas")}</button>}
                <button onClick={limparTodas} style={{ background:"none", border:"none", color:"#ef4444", cursor:"pointer", fontSize:11 }}>{t("header.limpar")}</button>
              </div>
            </div>
            <div style={{ maxHeight:380, overflowY:"auto" }}>
              {notifs.length === 0
                ? <div style={{ color:"var(--text3)", fontSize:13, padding:"32px 0", textAlign:"center" }}>
                    <div style={{ fontSize:28, marginBottom:8 }}>🔕</div>{t("header.sem_notificacoes")}
                  </div>
                : notifs.map(n => {
                    const t = TIPOS_COR[n.tipo] || TIPOS_COR.alerta;
                    return (
                      <div key={n.id} onClick={() => marcarLida(n.id)}
                        style={{ alignItems:"flex-start", background:n.lida?"transparent":t.bg, borderBottom:"1px solid var(--border)", cursor:"pointer", display:"flex", gap:10, padding:"12px 16px" }}
                        onMouseOver={e => e.currentTarget.style.background = "var(--bg4)"}
                        onMouseOut={e => e.currentTarget.style.background = n.lida ? "transparent" : t.bg}>
                        <div style={{ fontSize:18, flexShrink:0, marginTop:2 }}>{t.icon}</div>
                        <div style={{ flex:1, minWidth:0 }}>
                          <div style={{ alignItems:"center", display:"flex", justifyContent:"space-between" }}>
                            <div style={{ color:n.lida?"var(--text2)":t.cor, fontSize:13, fontWeight:n.lida?400:700 }}>{n.titulo}</div>
                            {!n.lida && <div style={{ background:t.dot, borderRadius:99, height:6, width:6 }} />}
                          </div>
                          <div style={{ color:"var(--text2)", fontSize:12, marginTop:2 }}>{n.msg}</div>
                          <div style={{ color:"var(--text3)", fontSize:10, marginTop:4 }}>{n.em}</div>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        )}
      </div>

      {!isMobile && (
        <div style={{ color:"var(--text2)", fontSize:12, flexShrink:0, whiteSpace:"nowrap" }}>
          {hora.toLocaleDateString(localeAtual, { day:"numeric", month:"short", year:"numeric" })} | {hora.toLocaleTimeString(localeAtual, { hour:"2-digit", minute:"2-digit" })}
        </div>
      )}

      {/* Auditoria de 21/08/2026: dentro do painel logado nao existia
          NENHUMA forma de trocar de idioma -- o LanguageSwitcher so era
          renderizado na landing/login (ver comentario no proprio
          componente). Cliente que assina em EN/ES ficava preso no idioma
          que estava salvo no localStorage no momento do cadastro, sem
          conseguir mudar depois de logado. */}
      <LanguageSwitcher dark={true} style={{ flexShrink: 0 }} />

      </div>

      {aberto && <div onClick={() => setAberto(false)} style={{ bottom:0, left:0, position:"fixed", right:0, top:0, zIndex:998 }} />}
    </div>
  );
}
